import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components

// Soft UI Dashboard PRO React components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import NewMarketsFilter from "views/markets/markets-config/create";

import { getData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

import { useSoftUIController } from "context";

function CreateMarketsFilter({ id, data, showModal, signalCloseModal }) {
  const [controller, dispatch] = useSoftUIController();
  const { platform } = controller;
  const [open, setOpen] = useState(false);
  const [initProviders, setInitProviders] = useState([]);
  const [mode, setMode] = useState("create");
  const [initOptions, setInitOptions] = useState(false);
  const [checkChanges, setCheckChanges] = useState(false);

  const handleCancelCreation = (e, update) => {
    e.preventDefault();
    setCheckChanges(true);
  };

  const handleCloseCreation = (e, update) => {
    e.preventDefault();
    if (e.type == "cancel cancel") {
      //setOpen(false);
      //signalCloseModal(false);
      setCheckChanges(false);
    } else {
      setOpen(false);
      signalCloseModal(update);
      if (update) {
        //console.log("calling from update");
        //getAvailableTemplates();
      }
      setCheckChanges(false);
    }
  };

  async function initData() {
    //await getAvailableTemplates();
    if (id != 0 && id != "0") {
      setMode("edit");
    } else {
      setMode("create");
    }
  }

  async function getAvailableTemplates() {
    if (initOptions) return false;
    if (!platform || platform == "") return false;
    //console.log("getAvailableTemplates proceded");
    setInitOptions(true);
    let getAvailableProvidersEndpoint = `/api/v1/platforms/${platform.value}/master-template`;
    let providers = await getData(getAvailableProvidersEndpoint, {
      Authorization: getAuthorizationHeader(),
    });
    if (providers && providers != null) {
      let providersOptions = [];
      providers.data.providers.forEach((el) => {
        if (!el.oddFilter) {
          if (el.inplay != null && el.pregame != null) {
            providersOptions.push({
              id: el.id,
              name: el.name,
            });
          }
        }
      });

      setInitProviders(providersOptions);
    } else {
    }
  }

  useEffect(() => {
    setOpen(showModal);
    if (showModal) initData();
  }, [showModal]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={(e) => handleCancelCreation(e, false)}
        fullWidth={true}
        maxWidth={"xxl"}
        sx={{ className: "dialog-overflow" }}
      >
        <DialogTitle>
          {id > 0 ? "Edit Existing Markets Settings" : "Create New Markets Settings"}
        </DialogTitle>
        <DialogContent style={{ overflow: "hidden" }}>
          <NewMarketsFilter
            signalCloseModal={handleCloseCreation}
            id={id}
            initData={data}
            providers={initProviders}
            checkChanges={checkChanges}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

// Setting default values for the props of CreatePlatform
CreateMarketsFilter.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreatePlatform
CreateMarketsFilter.propTypes = {
  id: PropTypes.number,
  data: PropTypes.object,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
};

export default CreateMarketsFilter;
